import React, { useCallback } from 'react';
import { Counter, Dropdown } from '@hpstellar/core';

import StickyBar from '../../../vwa/components/sticky-bar';
import VWAFilterCount from '../../../plp/components-v2/vwa-filter-count';
import SaleMobileFilter from '../sale-mobile-filter';
import StickyTab from './sticky-tabs';
import useHeaderFooter from '../../../hooks/useHeaderFooter';
import { ErrorBoundary } from '../../../shared/components/error-boundary';

export const SLPResultsBar = ({
    changeSort,
    sortOptions,
    productCat,
    productListLength,
    gotFinalProducts,
    ToggleFilter,
    sortGtmActions,
}) => {
    return (
        <div className="slp-results-bar">
            <div className="filter-toggle-container">
                {ToggleFilter}
                <VWAFilterCount count={productListLength} />
            </div>
            <span className="search-hits v2">
                {productListLength > 0 && gotFinalProducts && (
                    <Counter className="counter" count={productListLength} size="large" subsetDelimiter="of">
                        {`Result${productListLength > 1 ? 's' : ''}`}
                    </Counter>
                )}
            </span>
            <span className="search-sort-container">
                <ErrorBoundary>
                    <Dropdown
                        key={productCat.sortValue}
                        className="sort-dropdown"
                        options={sortOptions}
                        onChange={changeSort}
                        customLabel="Sort By"
                        defaultValue={productCat.sortValue}
                        gtmActions={sortGtmActions}
                    />
                </ErrorBoundary>
            </span>
        </div>
    );
};

export default ({
    tabProps,
    changeSort,
    sortOptions,
    productCat,
    productListLength,
    gotFinalProducts,
    ToggleFilter,
    sortGtmActions,
    disableSearch,
    disableTabs = false,
    mobileNested = true,
}) => {
    const { updateHeader } = useHeaderFooter();
    const onStickyChange = useCallback(inRange => {
        updateHeader({ disableCart: inRange });
        return function cleanup() {
            updateHeader({ disableCart: false });
        };
    });
    const mobileFilters = (
        <SaleMobileFilter
            setSort={changeSort}
            sortOptions={sortOptions}
            sortValue={productCat.sortValue}
            resultCount={productListLength}
            label={disableSearch ? 'SORT' : undefined}
        />
    );

    return (
        <>
            {!mobileNested && mobileFilters}
            <StickyBar
                id="slpStickyBar"
                height={'60px'}
                onStickyChange={onStickyChange}
                className="slp-results-bar-container"
            >
                {({ inRange }) => {
                    return (
                        <>
                            {inRange && !disableTabs && <StickyTab tabProps={tabProps} />}
                            {mobileNested && mobileFilters}
                            <SLPResultsBar
                                changeSort={changeSort}
                                sortOptions={sortOptions}
                                productCat={productCat}
                                productListLength={productListLength}
                                gotFinalProducts={gotFinalProducts}
                                ToggleFilter={ToggleFilter}
                                sortGtmActions={sortGtmActions}
                                disableSearch={disableSearch}
                            />
                        </>
                    );
                }}
            </StickyBar>
        </>
    );
};
